import { gql } from "@apollo/client";

export const GET_ALL_PLATFORMS = gql`
  query {
    allPlatforms {
      platforms
    }
  }
`;
